// This file is autogenerated. Any changes will be overwritten.

export const set = 'budicon';

export const name = 'plus-line-right';

export const Component = () => (
  <path d='M17 15.74h7.807L24.855 3h-.958v11.781H17v.959Zm-11.11 0v5.89h.958v-5.89h5.891v-.958H6.85v-5.89h-.96v5.89H0v.958h5.89Z' />
);

export const viewBox = '0 0 25 25';
